// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".links[data-v-7da4cdbf],form#login[data-v-7da4cdbf]{margin-top:20px}.links[data-v-7da4cdbf],.submit-error[data-v-7da4cdbf]{margin-bottom:20px}.submit-error[data-v-7da4cdbf]{color:#9081e6}", ""]);
// Exports
module.exports = exports;
